import { BaseApiService } from '@shared/services/BaseApiService';

class ModulesServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getList(user_id) {
    return this.http.get(`${user_id}/modules`);
  }

  updateStatus(user_id, params) {
    return this.http.put(`${user_id}/modules/predictive`, params);
  }
}

export const ModulesService = new ModulesServiceClass({
  api_version: 2,
  resource: 'users'
});
